import { BaseApiClient } from './base-client';
import type { ApiResponse } from '../../types';

export interface UserAssistant {
  id: number;
  user_id: number;
  name: string;
  description: string;
  system_prompt: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface AssistantLimits {
  current: number;
  max: number;
  tier: string;
}

/**
 * User Assistants API - CRUD для пользовательских ассистентов
 */
export class UserAssistantsApi extends BaseApiClient {

  /**
   * Получить все ассистенты пользователя
   */
  async getUserAssistants(): Promise<ApiResponse<{ assistants: UserAssistant[]; limits: AssistantLimits }>> {
    const response = await this.client.get('/api/chat/assistants');
    return response.data;
  }

  /**
   * Создать нового ассистента
   */
  async createAssistant(data: {
    name: string;
    description: string;
    system_prompt: string;
  }): Promise<ApiResponse<{ assistant: UserAssistant; limits: AssistantLimits }>> {
    const response = await this.client.post('/api/chat/assistants', data);
    return response.data;
  }

  /**
   * Обновить ассистента
   */
  async updateAssistant(id: number, updates: {
    name?: string;
    description?: string;
    system_prompt?: string;
  }): Promise<ApiResponse<{ assistant: UserAssistant }>> {
    const response = await this.client.put(`/api/chat/assistants/${id}`, updates);
    return response.data;
  }

  /**
   * Удалить ассистента
   */
  async deleteAssistant(id: number): Promise<ApiResponse<{ message: string }>> {
    const response = await this.client.delete(`/api/chat/assistants/${id}`);
    return response.data;
  }
}
